"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _vue = _interopRequireDefault(require("vue"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var _elementUi = require("element-ui");

var _translations = require("@/translations");

var i18n = (0, _translations.createTranslation)(_vue.default);
var helper = new _helper.Helper();
var failedLogin = {
  isSuccess: false,
  route: ''
};

var getNoAuthLoginParams = function getNoAuthLoginParams() {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, process.env.VUE_APP_CUSTOMER_KEY, process.env.VUE_APP_CUSTOMER_KEY_HASH), (0, _defineProperty2.default)(_ref, "test", process.env.VUE_APP_DEBUG_MODE || 'false'), (0, _defineProperty2.default)(_ref, "type", 'planning'), _ref;
}; // NOTE: length of the throwaway prefix the backend puts in front of each half of the login `key`


var LOGIN_KEY_PREFIX_LENGTH = 3; // NOTE: builds the session userKey (`token|custKey|apiToken`) from a login / SSO payload.
// The login api no longer exposes `custKey` and `apiToken` as named fields, it returns
// `key: '<3 chars><custKey>|<3 chars><apiToken>'` instead, so both halves are split on `|`
// and their first 3 characters are dropped. The old fields are still read as a fallback
// so an endpoint that has not switched yet keeps working. Returns '' on an incomplete key

var buildUserKey = function buildUserKey(loginData) {
  if (!loginData || !loginData['token']) {
    return '';
  }

  var custKey = '';
  var apiToken = '';

  if (loginData['key']) {
    var _String$split = String(loginData['key']).split('|'),
        _String$split2 = (0, _slicedToArray2.default)(_String$split, 2),
        _String$split2$ = _String$split2[0],
        rawCustKey = _String$split2$ === void 0 ? '' : _String$split2$,
        _String$split2$2 = _String$split2[1],
        rawApiToken = _String$split2$2 === void 0 ? '' : _String$split2$2;

    custKey = rawCustKey.substring(LOGIN_KEY_PREFIX_LENGTH);
    apiToken = rawApiToken.substring(LOGIN_KEY_PREFIX_LENGTH);
  } else {
    custKey = loginData['custKey'] || '';
    apiToken = loginData['apiToken'] || '';
  }

  if (!custKey || !apiToken) {
    return '';
  }

  return "".concat(loginData['token'], "|").concat(custKey, "|").concat(apiToken);
}; // NOTE: both the plain login and the OTP second step end with the same loginData,
// so the session cookie and store state are written in one place


var saveLoginSession = function saveLoginSession(commit, loginData, remember) {
  var expiry = remember ? 5 : 1;
  var userkey = buildUserKey(loginData);
  var domain = helper.getDomain();
  helper.setCookie(process.env.VUE_APP_AUTH_COOKIE, userkey, domain, expiry);
  helper.setCookie(process.env.VUE_APP_LOGFLOWS_COOKIE, 1, domain, expiry);
  commit('SET_IS_LOGIN', true);
  commit('SET_USER_KEY', userkey);
  commit('SET_LF_TOKEN', userkey.split('|')[0]);
  commit('SET_LF_CUST_KEY', userkey.split('|')[1]);
  commit('SET_LF_API_TOKEN', userkey.split('|')[2]);
};

var actions = {
  // NOTE: an OTP user is answered with hasOtp + otpToken instead of loginData, the login page
  // then asks for the emailed code and verifyOtp trades both for the real session.
  // Calling this again with the same credentials is also how a new code is resent
  logInUser: function logInUser(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var loginData = _ref3.loginData,
        remember = _ref3.remember,
        logflows = _ref3.logflows;

    if (!logflows) {
      if (loginData['username'] === process.env.VUE_APP_ADMIN_USER && loginData['password'] === process.env.VUE_APP_ADMIN_PASS) {
        var domain = helper.getDomain();
        helper.setCookie(process.env.VUE_APP_AUTH_COOKIE, process.env.VUE_APP_ADMIN_KEY, domain, 1);
        helper.setCookie(process.env.VUE_APP_LOGFLOWS_COOKIE, 0, domain, 1);
        commit('SET_IS_LOGIN', true);
        commit('SET_USER_KEY', process.env.VUE_APP_ADMIN_KEY);
        return Promise.resolve({
          isSuccess: true,
          route: '/admin-dashboard'
        });
      } else {
        // API CALL FOR NOT LOGFLOWS USERS
        return Promise.resolve(failedLogin);
      }
    }

    var requestLogin = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    return requestLogin.post('ROUTING', 'v2/noauth/verify', getNoAuthLoginParams(), loginData).then(function (res) {
      if (res.failed) {
        return failedLogin;
      }

      if (helper.get(res, 'data.hasOtp', false)) {
        return {
          isSuccess: true,
          route: '',
          hasOtp: true,
          isOtpSent: Boolean(helper.get(res, 'data.verificationSend', false)),
          otpToken: helper.get(res, 'data.otpToken', '')
        };
      }

      saveLoginSession(commit, helper.get(res, 'data.loginData', {}), remember);
      return {
        isSuccess: true,
        route: '/dashboard'
      };
    }).catch(function () {
      return failedLogin;
    });
  },
  verifyOtp: function verifyOtp(_ref4, _ref5) {
    var commit = _ref4.commit;
    var token = _ref5.token,
        passwordKey = _ref5.passwordKey,
        remember = _ref5.remember;
    var requestVerify = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    return requestVerify.post('ROUTING', 'v2/noauth/verify-token', getNoAuthLoginParams(), {
      token: token,
      passwordKey: passwordKey
    }).then(function (res) {
      var loginData = helper.get(res, 'data.loginData', null);

      if (res.failed || !loginData || !loginData['token']) {
        return failedLogin;
      }

      saveLoginSession(commit, loginData, remember);
      return {
        isSuccess: true,
        route: '/dashboard'
      };
    }).catch(function () {
      return failedLogin;
    });
  },
  logInSSO: function logInSSO(_ref6, _ref7) {
    var commit = _ref6.commit,
        state = _ref6.state;
    var loginData = _ref7.loginData,
        remember = _ref7.remember,
        logflows = _ref7.logflows;
    var requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    var params = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, process.env.VUE_APP_CUSTOMER_KEY_HASH);
    return requestAuth.post('ROUTING', "v1/auth/sso?test=".concat(process.env.VUE_APP_DEBUG_MODE || 'false', "&type=planning"), params, loginData).then(function (data) {
      if (data.failed) {
        var message = {
          title: i18n.t('notification.login.failed'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        return false;
      }

      var expiry = remember ? 5 : 1;
      var userkey = buildUserKey(data['data']);
      var domain = helper.getDomain();
      helper.setCookie(process.env.VUE_APP_AUTH_COOKIE, userkey, domain, expiry);
      helper.setCookie(process.env.VUE_APP_LOGFLOWS_COOKIE, 1, domain, expiry);
      commit('SET_IS_LOGIN', true);
      commit('SET_USER_KEY', userkey);
      commit('SET_LF_TOKEN', userkey.split('|')[0]);
      commit('SET_LF_CUST_KEY', userkey.split('|')[1]);
      commit('SET_LF_API_TOKEN', userkey.split('|')[2]);
      return true;
    }).catch(function () {
      return false;
    });
  },
  logOutUser: function logOutUser(_ref8) {
    var commit = _ref8.commit;
    var domain = helper.getDomain();
    helper.deleteCookie(process.env.VUE_APP_AUTH_COOKIE, domain);
    helper.deleteCookie(process.env.VUE_APP_LOGFLOWS_COOKIE, domain);
    commit('SET_IS_LOGIN', false);
    commit('SET_USER_KEY', '');
    commit('SET_LF_TOKEN', '');
    commit('SET_LF_CUST_KEY', '');
    commit('SET_LF_API_TOKEN', '');
    commit('SET_USER_INFORMATION', {});
  },
  loadUserInformation: function loadUserInformation(_ref9, userInformation) {
    var commit = _ref9.commit;

    if (Number(helper.getCookie(process.env.VUE_APP_LOGFLOWS_COOKIE)) === 0) {
      if (userInformation['lfToken'] === process.env.VUE_APP_ADMIN_KEY) {
        commit('SET_USER_INFORMATION', {
          user: {
            name: 'administrator'
          },
          company: {
            name: 'Logflows',
            country: 'hk'
          },
          customerKey: process.env.VUE_APP_CUSTOMER_KEY_HASH
        });
        commit('SET_IS_ADMIN', true);
        return Promise.resolve(true);
      } else {
        // API CALL FOR NOT LOGFLOWS USERS
        return Promise.resolve(false);
      }
    }

    var userKey = userInformation['lfToken'];
    var requestAuth = new _request.Request('application/json', userKey);
    var requestAi = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    return requestAuth.get('LEGACY_USER', "myuser?test=".concat(process.env.VUE_APP_DEBUG_MODE || 'false', "&type=planning")).then(function (data) {
      var _requestAi$get;

      if (!data['data'] || helper.isEmptyObject(data['data'])) {
        return Promise.reject('1');
      }

      if (helper.isEmpty(data['data']['customerKey'])) {
        return Promise.reject('2');
      }

      commit('SET_USER_INFORMATION', data['data']);
      commit('SET_IS_ADMIN', false);
      return requestAi.get('AI_CUSTOMER', data['data']['customerKey'], (_requestAi$get = {}, (0, _defineProperty2.default)(_requestAi$get, process.env.VUE_APP_CUSTOMER_KEY, process.env.VUE_APP_CUSTOMER_KEY_HASH), (0, _defineProperty2.default)(_requestAi$get, "key", 'key'), _requestAi$get));
    }).then(function (data) {
      if (!data['data'] || helper.isEmptyObject(data['data'])) {
        return Promise.reject('1');
      }

      var datas = {
        id: data['data']['_id'] || '',
        company: data['data']['company'] || '',
        country: data['data']['data'] && data['data']['data']['country'] ? data['data']['data']['country'] : '',
        latlng: data['data']['data'] && data['data']['data']['latlng'] ? data['data']['data']['latlng'] : '',
        timezone: data['data']['data'] && data['data']['data']['timezone'] ? data['data']['data']['timezone'] : 8,
        updateUserData: data['data']['data'] && data['data']['data']['updateUserData'] ? data['data']['data']['updateUserData'] : false,
        checkReadyToShip: data['data']['data'] && data['data']['data']['checkReadyToShip'] ? data['data']['data']['checkReadyToShip'] : false,
        orderAssignmentReadyToShip: data['data']['data'] && data['data']['data']['orderAssignmentReadyToShip'] ? data['data']['data']['orderAssignmentReadyToShip'] : false,
        permission: data['data']['data'] && data['data']['data']['permission'] ? data['data']['data']['permission'] : [],
        planIdFormat: data['data']['data'] && data['data']['data']['planIdFormat'] ? data['data']['data']['planIdFormat'] : process.env.VUE_APP_PLANIDCODE
      };
      var settings = {
        default1: data['data']['default1'] && (data['data']['default1'] === 'True' || data['data']['default1'] === 'true'),
        default2: data['data']['default2'] && (data['data']['default2'] === 'True' || data['data']['default2'] === 'true'),
        default3: data['data']['default3'] && (data['data']['default3'] === 'True' || data['data']['default3'] === 'true'),
        default4: data['data']['default4'] && (data['data']['default4'] === 'True' || data['data']['default4'] === 'true'),
        default5: data['data']['default5'] && (data['data']['default5'] === 'True' || data['data']['default5'] === 'true'),
        default6: data['data']['default6'] ? data['data']['default6'] : '',
        default7: data['data']['default7'] ? data['data']['default7'] : 0,
        default8: data['data']['default8'] ? data['data']['default8'] : 0,
        default9: data['data']['default9'] && (data['data']['default9'] === 'True' || data['data']['default9'] === 'true'),
        default10: data['data']['default10'] && (data['data']['default10'] === 'True' || data['data']['default10'] === 'true'),
        default11: data['data']['default11'] ? data['data']['default11'] : 1,
        default12: data['data']['default12'] ? data['data']['default12'] : '',
        default13: data['data']['default13'] ? data['data']['default13'] : 0,
        default14: data['data']['default14'] ? data['data']['default14'] : 30,
        default15: data['data']['default15'] ? data['data']['default15'] : 0,
        default16: data['data']['default16'] ? data['data']['default16'] : [{
          truck: '',
          commodity: ''
        }],
        default17: data['data']['default17'] ? data['data']['default17'] : 70,
        default18: data['data']['default18'] ? data['data']['default18'] : 30,
        default19: data['data']['default19'] ? data['data']['default19'] : [],
        default20: data['data']['default20'] && (data['data']['default20'] === 'True' || data['data']['default20'] === 'true'),
        default21: data['data']['default21'] && (data['data']['default21'] === 'True' || data['data']['default21'] === 'true'),
        default22: data['data']['default22'] ? data['data']['default22'] : 60,
        default23: data['data']['default23'] ? data['data']['default23'] : 1800,
        default24: data['data']['default24'] && (data['data']['default24'] === 'True' || data['data']['default24'] === 'true'),
        default25: data['data']['default25'] ? data['data']['default25'] : 1,
        default26: data['data']['default26'] ? data['data']['default26'] : 1,
        default27: data['data']['default27'] && (data['data']['default27'] === 'True' || data['data']['default27'] === 'true'),
        default28: data['data']['default28'] && (data['data']['default28'] === 'True' || data['data']['default28'] === 'true'),
        default29: data['data']['default29'] ? data['data']['default29'] : 0,
        default30: data['data']['default30'] ? data['data']['default30'] : 'default',
        default31: data['data']['default31'] && (data['data']['default31'] === 'True' || data['data']['default31'] === 'true'),
        default32: data['data']['default32'] && (data['data']['default32'] === 'True' || data['data']['default32'] === 'true'),
        default33: data['data']['default33'] ? data['data']['default33'] : 0,
        hook1: data['data']['hook1'] ? data['data']['hook1'] : null,
        hook2: data['data']['hook2'] ? data['data']['hook2'] : null,
        hook3: data['data']['hook3'] ? data['data']['hook3'] : null,
        hook4: data['data']['hook4'] ? data['data']['hook4'] : null,
        hook5: data['data']['hook5'] ? data['data']['hook5'] : null
      };
      commit('SET_USER_DATA', datas);
      commit('SET_USER_SETTING', settings);
      return true;
    }).catch(function (error) {
      return error;
    });
  },
  updateUserSetting: function updateUserSetting(_ref10, settingInformation) {
    var commit = _ref10.commit;
    commit('UPDATE_USER_SETTING', settingInformation);
  }
};
exports.actions = actions;